var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/** @jsx jsx */
import { jsx } from 'theme-ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusCircle } from '@fortawesome/pro-solid-svg-icons';
import { useState, useCallback, useEffect, useRef, Fragment, } from 'react';
import { Spinner } from './Spinner';
import { FlexRow } from './FlexRow';
import { Card } from './Card';
import { Clickable } from './Clickable';
import { TextField } from './TextField';
var itemStyle = {
    py: 2,
    px: 3,
    cursor: 'pointer',
    borderStyle: 'solid',
    borderColor: 'grey',
    borderBottomWidth: 1,
    borderTopWidth: 0,
    borderLeftWidth: 0,
    borderRightWidth: 0,
    '&:last-child': {
        borderBottomWidth: 0,
    },
    '&:hover': {
        backgroundColor: 'light',
    },
};
export function SearchableList(_a) {
    var busy = _a.busy, creatable = _a.creatable, createPrompt = _a.createPrompt, items = _a.items, onCreate = _a.onCreate, onSearchChange = _a.onSearchChange, onSelect = _a.onSelect, placeholder = _a.placeholder, renderItem = _a.renderItem, itemIsDisabled = _a.itemIsDisabled, renderValue = _a.renderValue, search = _a.search, value = _a.value, disabled = _a.disabled, className = _a.className, id = _a.id, _searchRef = _a.searchRef, prompt = _a.prompt, variant = _a.variant;
    var _b = useState(false), open = _b[0], setOpen = _b[1];
    var _c = useState(null), index = _c[0], setIndex = _c[1];
    var onFocus = useCallback(function () {
        setOpen(true);
    }, []);
    var onBlur = useCallback(function () {
        setOpen(false);
    }, []);
    useEffect(function () {
        setOpen(false);
        onSearchChange('');
    }, [value, onSearchChange]);
    useEffect(function () {
        if (search) {
            setOpen(true);
        }
    }, [search]);
    var localSearchRef = useRef(null);
    var searchRef = _searchRef || localSearchRef;
    var previousValue = useRef(value);
    var cardRef = useRef();
    useEffect(function () {
        if (value !== previousValue.current) {
            if (!value && searchRef.current) {
                // searchRef.current.focus();
            }
            else if (value && cardRef.current) {
                // cardRef.current.focus();
            }
        }
        previousValue.current = value;
        setIndex(null);
    }, [search, searchRef, value]);
    var onKeyDown = useCallback(function (e) {
        if (e.key === 'ArrowDown') {
            setIndex(function (index) {
                return index === null ? 0 : (index + 1) % (items.length + 1);
            });
        }
        else if (e.key === 'ArrowUp') {
            setIndex(function (index) {
                return index === 0 || index === null ? items.length + 1 : index - 1;
            });
        }
        else if (e.key === 'Enter') {
            if (index != null) {
                if (index < items.length) {
                    var item = items[index];
                    if (item &&
                        onSelect &&
                        (!itemIsDisabled || !itemIsDisabled(item))) {
                        onSelect(item);
                        setOpen(false);
                    }
                }
                else if (onCreate) {
                    onCreate();
                }
            }
        }
        else if (e.key === 'Escape') {
            setOpen(false);
            onSearchChange('');
        }
        else
            return;
        e.preventDefault();
    }, [index, itemIsDisabled, items, onCreate, onSearchChange, onSelect]);
    return (jsx("div", { className: className, sx: { position: 'relative' } },
        value ? (jsx(Card, { sx: { px: 1, py: 2 }, as: Clickable, ref: cardRef, onClick: onSelect && !disabled ? function () { return onSelect(undefined); } : undefined }, renderValue ? renderValue(value) : renderItem(value))) : (jsx(TextField, { value: search, variant: variant, onChange: function (e) { return onSearchChange(e.target.value); }, placeholder: placeholder, onFocus: onFocus, onBlur: onBlur, ref: searchRef, id: id, onKeyDown: onKeyDown, onClick: function () {
                setOpen(true);
            } })),
        (items.length > 0 || search.length > 0 || creatable || prompt) && (jsx(Card, { sx: {
                position: 'absolute',
                borderStyle: 'solid',
                width: '100%',
                display: open ? 'block' : 'none',
                boxShadow: '3px 3px 5px 1px rgba(0, 0, 0, 0.2)',
                zIndex: 'dropdown',
                maxHeight: 200,
                overflowY: 'auto',
            } },
            prompt && !search.length && items.length === 0 && (jsx("div", { sx: { py: 2, px: 3, color: 'muted' } }, prompt)),
            busy ? (jsx(FlexRow, { sx: {
                    justifyContent: 'space-between',
                    py: 2,
                    px: 3,
                    fontSize: 2,
                    color: 'muted',
                } },
                jsx("span", null, "Searching..."),
                jsx(Spinner, { sx: { fontSize: 1 } }))) : items.length === 0 && search.length ? (jsx("div", { sx: { py: 2, px: 3, fontSize: 1, color: 'muted' } }, search.length > 0 && 'No results')) : null,
            items.length > 0 &&
                items.map(function (item, i) {
                    var disabled = itemIsDisabled && itemIsDisabled(item);
                    return (jsx("div", { sx: __assign(__assign({}, itemStyle), { bg: disabled ? '#eee' : i === index ? 'light' : 'white', cursor: disabled ? 'default' : 'pointer', '&:hover': { bg: disabled ? '#eee' : 'light' } }), key: i, onMouseDown: onSelect && !disabled
                            ? function () {
                                onSelect(item);
                            }
                            : undefined }, renderItem(item)));
                }),
            creatable && (jsx("div", { onMouseDown: onCreate, sx: __assign(__assign({}, itemStyle), { bg: index === items.length ? 'light' : 'white', color: 'secondary' }), id: "".concat(id, "-create") }, createPrompt || (jsx(Fragment, null,
                jsx(FontAwesomeIcon, { icon: faPlusCircle, sx: { mr: 2 } }),
                "Add ",
                search ? jsx("strong", null, search) : 'new'))))))));
}
//# sourceMappingURL=SearchableList.js.map